var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopMonitorHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3H20C21.1046 3 22 3.89543 22 5V14C22 15.1046 21.1046 16 20 16H14.0833L14.4375 20.25H16C16.4142 20.25 16.75 20.5858 16.75 21C16.75 21.4142 16.4142 21.75 16 21.75H8C7.58579 21.75 7.25 21.4142 7.25 21C7.25 20.5858 7.58579 20.25 8 20.25H9.5625L9.91667 16H4C2.89543 16 2 15.1046 2 14V5C2 3.89543 2.89543 3 4 3ZM10.2741 6.50093C10.1318 6.3413 9.92814 6.25 9.71429 6.25C9.50043 6.25 9.29674 6.3413 9.15444 6.50093L5.94955 10.0962H4C3.58579 10.0962 3.25 10.4319 3.25 10.8462C3.25 11.2604 3.58579 11.5962 4 11.5962H6.28571C6.49957 11.5962 6.70326 11.5049 6.84556 11.3452L9.71429 8.1271L13.6116 12.4991C13.7539 12.6587 13.9576 12.75 14.1714 12.75C14.3853 12.75 14.589 12.6587 14.7313 12.4991L17.2504 9.67308H20C20.4142 9.67308 20.75 9.33729 20.75 8.92308C20.75 8.50886 20.4142 8.17308 20 8.17308H16.9143C16.7004 8.17308 16.4967 8.26437 16.3544 8.42401L14.1714 10.8729L10.2741 6.50093Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMonitorHeart);
export default __webpack_public_path__ + "static/media/desktop-monitor-heart.50334141b9e76e3bee2cded5313c41ff.svg";
export { ForwardRef as ReactComponent };